import { render, staticRenderFns } from "./MinibusDemand.vue?vue&type=template&id=28c231f2&"
import script from "./MinibusDemand.vue?vue&type=script&lang=js&"
export * from "./MinibusDemand.vue?vue&type=script&lang=js&"
import style0 from "./MinibusDemand.vue?vue&type=style&index=0&id=28c231f2&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports